<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: utils.in_rem(12px);

    .title {
      @include mixins.title3();
    }
  }
</style>

<script>
  import IconButton from "@sourcewhale/shared/svelte-design-system/components/atoms/IconButton.svelte";
  import InlineNotification from "@sourcewhale/shared/svelte-design-system/components/atoms/InlineNotification.svelte";
  import { additionsStore } from "../stores";

  let { mod, notification = "" } = $props();

  const onclick = () => {
    $additionsStore = Object.fromEntries(
      Object.entries($additionsStore).filter(([l]) => l !== mod.kind)
    );
  };
</script>

<div class="header" class:notification>
  <span class="title">{mod.title}</span>
  {#if notification}
    <InlineNotification style="flex:1">{notification}</InlineNotification>
  {/if}
  <IconButton icon="fa-regular fa-xmark" {onclick}>
    <span slot="tooltip">Remove</span>
  </IconButton>
</div>
